/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { NvHigListInsertData, NvHigListItemData } from '../../models/hig-list-item.types';
import { NvHigListInsertComponent } from '../nv-hig-list-insert/nv-hig-list-insert.component';
import { NvHigListItemComponent } from '../nv-hig-list-item/nv-hig-list-item.component';

export type ResourceType = 'incremental' | 'decremental';

@Component({
    selector: 'nv-hig-resource-progress-bar',
    templateUrl: './nv-hig-resource-progress-bar.component.html',
    styleUrls: ['./nv-hig-resource-progress-bar.component.scss'],
    imports: [NvHigListItemComponent, MatProgressBarModule, NvHigListInsertComponent]
})
export class NvHigResourceProgressBarComponent {
    @Input() resourceType: ResourceType = 'decremental';
    @Input() isWarningState: boolean = false;
    @Input() resourceRemainingCardData: NvHigListItemData;
    @Input() resourceTotalCardData: NvHigListItemData;
    @Input() warningMessageData: NvHigListInsertData;
    @Input() progressValue: number;
    @Input() isFullResourceState: boolean = false;

    // Accessibility configuration inputs
    @Input() ariaLabel?: string;
    @Input() ariaValueMin?: number;
    @Input() ariaValueMax?: number;
    @Input() ariaValueText?: string;
}
